/** @format */

// 用于保存iframe的window对象
const windowWeakMap = new WeakMap()

/**
 * window实例间通信
 * props: { window: WindowProxy; eventCallback?: EventCallBack }
 */
export default class WindowEventBus {
  constructor(props) {
    if (props.eventCallback) {
      this.eventCallback = props.eventCallback
    }

    this.conectWindow = props.window

    // _receiveMessage 需强制绑定this
    let receiveMessage = this._receiveMessage.bind(this)

    windowWeakMap.set(this, this.conectWindow)

    // 开启监听
    window.addEventListener('message', receiveMessage)

    // 生成移除监听函数，这样才生效
    this.removeEventListener = () => {
      window.removeEventListener('message', receiveMessage)
    }
  }

  conectWindow = null // 连接的window对象

  eventList = []

  eventCallback = null

  /**
   * 注册事件
   * @param {*} type 事件类型
   * @param {*} cb ({type,content})=>void
   */
  $on(type, cb) {
    const event = {
      type,
      cb,
    }
    this.eventList.push(event)
  }

  /**
   *
   * @param {*} type string 消息类型
   * @param {*} data Object 消息内容
   */
  $emit(type, data) {
    if (this.conectWindow) {
      this.conectWindow.postMessage(
        {
          type,
          data,
        },
        '*',
      )
    }
  }

  /**
   * 移除事件
   * @param {*} type
   * @param {*} cb
   */
  $off(type, cb) {
    this.eventList = this.eventList.filter(e => !(e.type === type && cb === e.cb))
  }

  /**
   * 清空事件列表
   */
  clearEventList() {
    this.eventList = []
  }

  /**
   * 移除windowd的message事件
   */
  removeEventListener = null

  /**
   * 接受事件处理
   * @param {*} event MessageEvent
   */
  _receiveMessage(event) {
    // 检测是否有已销毁的 iframe 还在监听
    if (!windowWeakMap.get(this) || windowWeakMap.get(this).closed) {
      // 移除事件监听
      windowWeakMap.delete(this)
      this.removeEventListener()

      return
    }

    this.eventCallback && this.eventCallback(event ? event.data : '')

    if (event && event.data) {
      const {
        data: { type, data },
      } = event
      this.eventList
        .filter(e => e.type === type)
        .forEach(({ cb }) => {
          cb(data) // eslint-disable-line
        })
    }
  }
}

/**
 * 父窗口与当前页面通信实例
 */
export const parentWindowEventBus = new WindowEventBus({
  window: window.parent || window,
})